<template lang="pug">
    td.dt-checkbox
        label.md-check
            input.has-value(
                type="checkbox",
                :value="key",
                :checked="isSelected(key)",
                @click="toggleSelected(key)",
                :disabled="isCheckboxDisabled",
            )
            i.indigo
</template>

<script>
import mixins from '../mixins';

export default {
    mixins: [mixins],

    props: {
        row: {
            type: Object,
            required: true,
        },
    },

    computed: {
        key() {
            return this.row[this.options.uniqueKey];
        },

        isCheckboxDisabled() {
            return this.options.checkboxDisableCallback(this.row);
        },
    },
};
</script>
